import styled from 'styled-components';
import ArrowRightDetailIconSVG from '../assets/hotels/details/arrow-right.svg';

const ArrowRightDetailIcon = styled(
  ArrowRightDetailIconSVG as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width};
  height: ${props => props.height};
  fill: ${props => props.color};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default ArrowRightDetailIcon;
